import { Checkbox, Flex, Tooltip, Typography } from 'antd';
import SetupSensorIcon from '../../../../assets/images/SetupSensorIcon.jsx';
import SensorInfoIcon from '../../../../assets/images/SensorInfoIcon.jsx';
import SensorInfoIconDisabled from '../../../../assets/images/SensorInfoIconDisabled.jsx';
import React from 'react';
import { sentenceCase } from '@/common/helper/appHelper.js';

const { Text } = Typography;

interface Shipment {
  sensor?: unknown;
}

interface Rule {
  alert_name: string;
  sensor_required?: string;
  sensor_status?: string;
  is_critical_type?: boolean;
  description?: string;

  [key: string]: unknown;
}

interface ShipmentAlertThresholdInputProps {
  isChecked: boolean;
  onCheckboxChange: (checked: boolean) => void;
  shipment?: Shipment;
  rule: Rule;
  enableAllThresholds?: boolean;
  gap?: number;
  disabled?: boolean;
  checkboxClassName?: string;
  applyCheckboxClass?: boolean;
}

const ShipmentAlertThresholdInput: React.FC<
  ShipmentAlertThresholdInputProps
> = ({
  isChecked,
  onCheckboxChange,
  shipment,
  rule,
  enableAllThresholds = false,
  gap = 24,
  disabled = false,
  checkboxClassName = 'custom-dropdown-export-coc-checkbox',
  applyCheckboxClass = false,
}) => {
  const checkboxDisabled =
    (rule?.sensor_required === 'required' &&
      !shipment?.sensor &&
      !enableAllThresholds) ||
    disabled;

  return (
    <Flex
      align='center'
      justify='flex-start'
      style={{
        gap,
        margin: '10px 0px',
        backgroundColor: isChecked ? 'var(--surface-selected)' : 'transparent',
        borderRadius: 8,
      }}
    >
      <Checkbox
        className={applyCheckboxClass ? checkboxClassName : undefined}
        disabled={checkboxDisabled}
        checked={isChecked}
        onChange={(e) => onCheckboxChange(e.target.checked)}
        style={{ margin: 0 }}
      />

      <Flex vertical style={{ paddingRight: 20, flex: 1, minWidth: 0 }}>
        <Flex align='center' gap={4} style={{ marginBottom: 4 }}>
          <Text style={{ fontSize: 14, lineHeight: '20px', fontWeight: 600 }}>
            {sentenceCase(rule.alert_name)}
          </Text>

          {rule?.sensor_status !== 'setup_required' && (
            <>
              {rule.sensor_required === 'required' &&
                (!shipment?.sensor && !enableAllThresholds ? (
                  <Tooltip title='Sensor required: The correct sensor must be connected to enable this alert'>
                    <SensorInfoIconDisabled className='svg-icon gray-icon hover-yellow' />
                  </Tooltip>
                ) : (
                  <Tooltip title='Sensor enabled'>
                    <SensorInfoIcon className='svg-icon gray-icon hover-blue' />
                  </Tooltip>
                ))}
            </>
          )}

          {rule?.is_critical_type && (
            <Tooltip title='Critical alert: An alert that is indicative of a potential product compromise'>
              <SetupSensorIcon className='svg-icon gray-icon hover-red' />
            </Tooltip>
          )}

          {rule?.sensor_status === 'optional' && (
            <Text
              className='dotted-border-spaced'
              style={{ fontSize: 12, color: 'var(--text-primary)' }}
            >
              {'(Sensor optional)'}
            </Text>
          )}
        </Flex>

        <Text
          type='secondary'
          style={{
            fontSize: 12,
            color: 'var(--text-secondary)',
            lineHeight: '18px',
          }}
        >
          {rule.description}
        </Text>
      </Flex>

      <Flex align='center' gap={8} />
    </Flex>
  );
};

export default ShipmentAlertThresholdInput;
